import classNames from "classnames"

const textAlign = {
    Center: "text-center",
    Left: "text-left",
    Right: "text-right",
} as const
const gridOptions = {
    "1": "grid-cols-1",
    "2": "grid-cols-1 md:grid-cols-2",
    "3": "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
} as const

export const useTextComponent = (
    columns: keyof typeof gridOptions,
    text_align: keyof typeof textAlign,
    textColor: string
) => {
    const column = gridOptions[columns] || gridOptions["1"]
    const textContainer = classNames("pt-2.5 md:px-5 md:pt-5", textAlign[text_align] || textAlign["Left"], textColor)
    return { column, textContainer }
}
